import { leagueRequiresRound } from './league-config';

export const cleanFormData = (formData: any): any => {
  const { title, _creativityType, ...config } = formData;
  // Limpiar región 4 si no está completa
  if (!config.time4 || !config.enableRegion4) {
    delete config.region4;
    delete config.time4;
  }

  // Eliminar switches internos
  delete config.enableRegion4;
  delete config.autoSyncTimes;

  // Lógica de round
  const shouldKeepRound = leagueRequiresRound(config.league);
  if (!shouldKeepRound) delete config.round;

  return config;
};
